// HotX TRON 充值前端状态工具，注释时间：2026-09-03 CST。链上与积分终态始终以后端事实为准。
import type { RechargeAssetCode, RechargeOrderStatus } from '../api/rechargeApi';

export type RechargeTagType = 'primary' | 'success' | 'warning' | 'danger' | 'info';

const statusMetadata: Record<RechargeOrderStatus, { label: string; tag: RechargeTagType; step: number }> = {
  CREATED: { label: '订单已创建', tag: 'primary', step: 0 },
  WAITING_PAYMENT: { label: '等待付款', tag: 'primary', step: 0 },
  PAYMENT_DETECTED: { label: '已检测到账', tag: 'warning', step: 1 },
  CONFIRMING: { label: '链上确认中', tag: 'warning', step: 2 },
  SUCCESS: { label: '积分已到账', tag: 'success', step: 4 },
  EXPIRED: { label: '订单已过期', tag: 'info', step: 0 },
  CANCELLED: { label: '订单已取消', tag: 'info', step: 0 },
  MANUAL_REVIEW: { label: '人工复核中', tag: 'warning', step: 2 },
  FAILED: { label: '处理失败', tag: 'danger', step: 2 }
};

export function rechargeStatusMeta(status: RechargeOrderStatus) {
  return statusMetadata[status] || { label: status, tag: 'info' as const, step: 0 };
}

export function isOpenRechargeOrder(status?: RechargeOrderStatus | null) {
  return status === 'CREATED'
    || status === 'WAITING_PAYMENT'
    || status === 'PAYMENT_DETECTED'
    || status === 'CONFIRMING'
    || status === 'MANUAL_REVIEW';
}

export function canCancelRechargeOrder(status?: RechargeOrderStatus | null) {
  return status === 'CREATED' || status === 'WAITING_PAYMENT';
}

export function formatRechargeCountdown(
  expiresAt?: string | null,
  now = Date.now(),
  providerPausedAt?: string | null
) {
  if (!expiresAt) return '等待订单时间';
  const expiry = Date.parse(expiresAt);
  if (!Number.isFinite(expiry)) return '等待订单时间';
  const pausedAt = providerPausedAt ? Date.parse(providerPausedAt) : Number.NaN;
  const effectiveNow = Number.isFinite(pausedAt) ? pausedAt : now;
  const totalSeconds = Math.max(0, Math.ceil((expiry - effectiveNow) / 1000));
  if (totalSeconds === 0) return '付款窗口已结束';
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export function normalizeRechargeAmount(value: string) {
  const trimmed = value.trim();
  if (!/^\d+(?:\.\d{1,3})?$/.test(trimmed)) return null;
  const [whole, fraction = ''] = trimmed.split('.');
  const normalized = `${whole.replace(/^0+(?=\d)/, '') || '0'}.${fraction.padEnd(3, '0')}`;
  return Number(normalized) > 0 ? normalized : null;
}

export function isValidTronAddress(value: string) {
  return /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(value.trim());
}

export function isValidTronTxid(value: string) {
  return /^[a-fA-F0-9]{64}$/.test(value.trim());
}

export function assetSymbol(assetCode?: RechargeAssetCode | null) {
  return assetCode === 'USDT_TRC20' ? 'USDT' : assetCode === 'TRX' ? 'TRX' : '-';
}

export function tronScanTransactionUrl(txid?: string | null) {
  return txid && isValidTronTxid(txid) ? `https://tronscan.org/#/transaction/${txid}` : '';
}

export function createRechargeRequestId() {
  if (globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID();
  }
  return `console-recharge-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}
